import PageWithTitleMixin from 'mixins/PageWithTitleMixin'

export const steps = [
    'practiceMissing',
    'ancillaryService',
    'practice',
    'practiceMembership',
    'registerPhysicians',
    'schedule',
    'proccedToDashboard',
]

export default {
    mixins: [PageWithTitleMixin],

    data() {
        return {
            progress: 0,
        }
    },

    computed: {
        pageTitle() {
            return this.$t('pages.auth.signup.title')
        },

        stepIndex() {
            return steps.findIndex((step) => step === this.$route.params.step)
        },
    },

    methods: {
        goToNextStep() {
            this.$router.push({ name: `auth.signup.${steps[this.stepIndex + 1]}` })
        },

        animateProgress() {
            // Slightly hacky way of triggering CSS transition on progress bar.
            const stepSize = 100 / (steps.length - 1)

            if (this.$router.previousRoute) {
                this.progress = Math.max(0, this.stepIndex - 1) * stepSize
                setTimeout(() => (this.progress = this.stepIndex * stepSize))
            } else {
                this.progress = this.stepIndex * stepSize
            }
        },
    },

    created() {
        this.animateProgress()
    },
}
